export const setWidgetsConfigurationsFeatureToggleFromStorage = (
  enabled: boolean,
) => {
  sessionStorage.setItem(
    `C8R-EnableWidgetsSideBarConfigurations`,
    `${enabled}`,
  );
};
